import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  delay = 0
}: SectionProps) {
  const {
    ref,
    isInView
  } = useScrollAnimation();
  return <section id={id} className={`py-16 md:py-24 ${className}`} data-id="element-92">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 20
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.6,
      delay,
      ease: 'easeOut'
    }} data-id="element-93">
        {children}
      </motion.div>
    </section>;
}